import React, { useState, useEffect } from 'react';
import styles from './MediaGallery.module.css';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import Image1 from '../../images/tata.jpg'
import Image2 from '../../images/blood-donation.jpg'
import Image3 from '../../images/pooram.jpg'
import Image4 from '../../images/ghee.jpg'
import Image5 from '../../images/Bramayugam-Coming-Soon-1.jpg'
import Image6 from '../../images/Premix.jpg'
import Image7 from '../../images/Insta-Post-1.jpg'
import Image8 from '../../images/Insta-Poster.jpg'
import Image9 from '../../images/lifting-solution-3.jpg'
import Image10 from '../../images/Liv-Long.jpg'
import Image11 from '../../images/Main-Poster.jpg'
import Image12 from '../../images/Page-01 (1).jpg'

import Image13 from '../../images/broucher-1.jpg'
import Image14 from '../../images/broucher-2.jpg'
import Image15 from '../../images/broucher-3.jpg'
import Image16 from '../../images/broucher-4.jpg'
import Image17 from '../../images/catalogue---29072024-outside.jpg'
import Image18 from '../../images/Inside.jpg'

import Image19 from '../../images/visiting-card-1.jpg'
import Image20 from '../../images/visiting-card-2.jpg'
import Image21 from '../../images/visiting-card-3.jpg'


const DesignGallery = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');

  // Scroll handler for header
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMouseMove = (e) => {
    setMousePosition({
      x: (e.clientX / window.innerWidth) * 20 - 10,
      y: (e.clientY / window.innerHeight) * 20 - 10
    });
  };

  const designs = [
    {
      id: 1,
      image: Image1
    },
    {
      id: 2,
      image: Image2
    },
    {
      id: 3,
      image: Image3
    },
    {
      id: 4,
      image: Image4
    },
    {
      id: 5,
      image: Image5
    },
    {
      id: 6,
      image: Image6
    },
    {
      id: 7,
      image: Image7
    },
    {
      id: 8,
      image: Image8
    },
    {
      id: 9,
      image: Image9
    },
    {
      id: 10,
      image: Image10
    },
    {
      id: 11,
      image: Image11
    },
    {
      id: 12,
      image: Image12
    },
    {
      id: 13,
      image: Image13
    },
    {
      id: 14,
      image: Image14
    },
    {
      id: 15,
      image: Image15
    },
    {
      id: 16,
      image: Image16
    },
    {
      id: 17,
      image: Image17
    },
    {
      id: 18,
      image: Image18
    }
    ,
    {
      id: 19,
      image: Image19
    },
    {
      id: 20,
      image: Image20
    },
    {
      id: 21,
      image: Image21
    }
  ];

  return (
    <div className={styles.pageWrapper}>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      
      <div className="gallery-container" onMouseMove={handleMouseMove}>
      {/* Animated Background */}
      <div className="animated-bg">
        <div 
          className="gradient-orb orb-1"
          style={{
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`
          }}
        ></div>
        <div 
          className="gradient-orb orb-2"
          style={{
            transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)`
          }}
        ></div>
        <div 
          className="gradient-orb orb-3"
          style={{
            transform: `translate(${mousePosition.x * 0.5}px, ${mousePosition.y * 0.5}px)`
          }}
        ></div>
        <div className="particles">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 20}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }}></div>
          ))}
        </div>
        <div className="grid-overlay"></div>
        <div className="wave-container">
          <svg className="waves" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path className="wave wave-1" d="M0,160L48,144C96,128,192,96,288,106.7C384,117,480,171,576,181.3C672,192,768,160,864,128C960,96,1056,64,1152,69.3C1248,75,1344,117,1392,138.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
          <svg className="waves" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path className="wave wave-2" d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,192C672,181,768,139,864,133.3C960,128,1056,160,1152,165.3C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </div>

      {/* Header */}
      <header className="gallery-header">
        <h1 className="gallery-title">
          <span className="title-gradient">Design Portfolio</span>
        </h1>
        <p className="gallery-subtitle">
          Explore our collection of creative designs
        </p>
      </header>

      {/* Main Heading and Description */}
      <div className="main-content-header">
        <h2 className="main-heading">Crafting Visual Stories That Inspire</h2>
        
        
      </div>

      {/* Gallery Grid - Images 1-12 */}
      <div className="gallery-grid">
        {designs.slice(0, 12).map((design, index) => (
          <div
            key={design.id}
            className="gallery-item"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={() => setSelectedItem(design)}
          >
            <div className="item-image-wrapper">
              <img
                src={design.image}
                alt={`Design ${design.id}`}
                className="item-image"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Description and Icons after Image 12 */}
      <p className="main-description">
        We transform ideas into stunning visual experiences. From bold posters to elegant brochures, 
        every design tells a unique story that captures attention and leaves a lasting impression.
      </p>
      <div className="icon-row">
        <div className="icon-item">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
          <span className="icon-label">Creative Design</span>
        </div>
        <div className="icon-item">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
          </svg>
          <span className="icon-label">Fast Delivery</span>
        </div>
        <div className="icon-item">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span className="icon-label">Client Focused</span>
        </div>
      </div>

      {/* Brochure Section */}
      <h2 className="section-heading">Brochure</h2>
      <div className="gallery-grid-brochure">
        {designs.slice(12, 16).map((design, index) => (
          <div
            key={design.id}
            className="gallery-item"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={() => setSelectedItem(design)}
          >
            <div className="item-image-wrapper">
              <img
                src={design.image}
                alt={`Design ${design.id}`}
                className="item-image"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Two Images in One Row (Images 17-18) */}
      <div className="gallery-grid-two">
        {designs.slice(16, 18).map((design, index) => (
          <div
            key={design.id}
            className="gallery-item"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={() => setSelectedItem(design)}
          >
            <div className="item-image-wrapper">
              <img
                src={design.image}
                alt={`Design ${design.id}`}
                className="item-image"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Description and Icons after Image 18 */}
      <p className="main-description">
        Professional design solutions that elevate your brand presence and create meaningful connections with your audience.
      </p>
      <div className="icon-row">
        <div className="icon-item">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
          <span className="icon-label">Creative Design</span>
        </div>
        <div className="icon-item">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
          </svg>
          <span className="icon-label">Fast Delivery</span>
        </div>
        <div className="icon-item">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span className="icon-label">Client Focused</span>
        </div>
      </div>

      {/* Visiting Card Section */}
      <h2 className="section-heading">Visiting Card</h2>
      <div className="gallery-grid-three">
        {designs.slice(18, 21).map((design, index) => (
          <div
            key={design.id}
            className="gallery-item"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={() => setSelectedItem(design)}
          >
            <div className="item-image-wrapper">
              <img
                src={design.image}
                alt={`Design ${design.id}`}
                className="item-image"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedItem && (
        <div className="modal-backdrop" onClick={() => setSelectedItem(null)}>
          <div className="modal-content-simple" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedItem(null)}>
              ×
            </button>
            <img
              src={selectedItem.image}
              alt={selectedItem.title}
              className="modal-image-full"
            />
          </div>
        </div>
      )}

      </div>
      
      <div className={styles.footerOverride}>
        <Footer mode={mode} background="illustrations" />
      </div>
    </div>
  );
};

export default DesignGallery;